import { React, useState, useEffect, useCallback, useRef } from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import { getAuthToken } from "../api/api";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { getAPIUrl, notify, information } from "../components/common/helpers";
import { ToastContainer } from "react-toastify";
import "../styles/Modal.css";
import "react-toastify/dist/ReactToastify.css";

export default function FirmwareReport() {
  let location = useLocation().state;
  const [viewAll, setViewAll] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const controller = new AbortController();
  const gridRef = useRef();

  const conditionalPopUpDisplay = () => {
    return location !== null && !viewAll;
  };

  const createServerRequest = (params) => {
   const {
      site_id = 0,
      component_type_id = 0,
      firmware_version = null,
    } = conditionalPopUpDisplay()  ? location.releaseData : { data: "" };
      const isRedirected = conditionalPopUpDisplay();
      const {startRow, endRow, filterModel, sortModel} = params;
      let sortQuery = '';
       let filterParams = '';
       if (sortModel && sortModel.length > 0 && sortModel !== undefined) {
        sortQuery = `&sortColumn=${sortModel[0].colId}&sortOrder=${sortModel[0].sort}`;
       }
       if (Object.keys(filterModel).length > 0) {
        filterParams = Object.keys(filterModel).map(field => {
          const filter = filterModel[field];
          return `&filter_${field}=${filter.filter}`
        }).join('');
       }
      return `?isRedirected=${isRedirected}&site_id=${site_id}&component_type_id=${component_type_id}&firmware_version=${firmware_version}&filter_page=${startRow}&filter_pageSize=${endRow}${filterParams}${sortQuery}`;
  }

  const showErrorOverlay = (gridApi) => {
    if (gridApi) {
      gridApi.showNoRowsOverlay();
    }
  };

  const handleApiError = (gridApi) => {
      showErrorOverlay(gridApi);
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  useEffect(() => {
    document.title = "Firmware Report";
    conditionalPopUpDisplay() &&
      information(location.releaseData);
  }, [location, viewAll]);

  useEffect(() => {
    if(gridApi) {
      getFirmwareReport();
    }
   }, [gridApi, viewAll]);

  const getFirmwareReport = async () => {
    if(!gridApi) return;
    const dataSource = {
      getRows: (params) => {
        const requestParameters = createServerRequest(params);
        gridApi.showLoadingOverlay();
        axios({
                    method: "GET",
                    url:
                      getAPIUrl("getReportData") + requestParameters,
                    headers: {
                      Authorization: getAuthToken(),
                    },
                    signal: controller.signal,
                  })
                    .then((res) => {
                      if (res && res.data.reportData.length > 0) {
                        const responseData = res.data.reportData.map((item) => ({
                          ...item,
                          firmware_ratio: `${item.aggregatecount} / ${item.total_count} `,
                        }));
                        params.successCallback(responseData,  res.data.lastRow);
                        gridApi.hideOverlay();
                      } 
                      else {
                        params.successCallback([], 0);
                        handleApiError(gridApi);
                      }
                    })
                    .catch((err) => {
                      params.successCallback([],  0);
                      params.failCallback();
                      handleApiError(gridApi);
                      (!viewAll && err.message !== "canceled") && notify("fetching");
                    });
      }
    }
    gridApi.setDatasource(dataSource);
  };

  const column = [
    {
      headerName: "Report Id",
      field: "report_id",
      floatingFilter: true,
    },
    {
      headerName: "Release Report",
      field: "firmware_ratio",
      floatingFilter: true,
      hide: !conditionalPopUpDisplay(),
    },
    {
      headerName: "Site",
      field: "building_name",
      floatingFilter: true,
    },
    {
      headerName: "Component Type",
      field: "component_type",
      floatingFilter: true,
    },
    {
      headerName: "Hardware Id",
      field: "component_id",
      floatingFilter: true,
    },
    {
      headerName: "Firmware Version",
      field: "firmware_version",
      floatingFilter: true,
    },
    {
      headerName: "Created Date",
      field: "created_date",
      floatingFilter: true,
    },
  ];
  const defaultColDef = {
    sortable: true,
    filter: true,
    flex: 1,
    resizable: true,
  };

  return (
    <>
      <h4 className="text-white p-2">Firmware Report</h4>
      <div
        className="container-fluid"
        style={{
          background: "#1F1F1F 0% 0% no-repeat padding-box",
          border: "1px solid #707070",
          width: "100%",
        }}
      >
        {!viewAll && location !== null && (
          <div className="text-end">
            <button className="link-button" onClick={(e) => {
              setViewAll(true)}}>
              View All Reports
            </button>
          </div>
        )}
        <div
          className="ag-theme-alpine-dark"
          style={{ height: 570, width: "100%", marginTop: "15px" }}
        >
          <AgGridReact
           onGridReady={onGridReady}
           ref={gridRef}
           rowModelType={"infinite"}
            columnDefs={column}
            defaultColDef={defaultColDef}
            pagination={true}
            paginationPageSize={10}
            cacheBlockSize={10}
            filter= {true}
            //sortable={true}
          ></AgGridReact>
        </div>
        <div className="py-2"></div>
          <ToastContainer
            style={{ width: "50%" }}
            closeOnClick={false}
            position="top-center"
            autoClose={3000}
            hideProgressBar={true}
            newestOnTop={false}
            limit={1}
          />
      </div>
    </>
  );
}
